import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pratica } from '../../interfaces/pratica';
import { LabelPipeModule } from '../_shared/label-pipe/label-pipe.module';
import { SharedModule } from '../_shared/shared.module';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { TaskManagerModule } from '../task-manager/task-manager.module';
@Component({
  standalone: true,
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  imports: [SharedModule, LabelPipeModule, TaskManagerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class HistoryComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Pratica,
    public dialogRef: MatDialogRef<HistoryComponent, boolean>
  ) {}

  onClose(event: boolean) {
    this.dialogRef.close(event);
  }
}
